import type { Person } from '../../eventsApi/persons/person'
import type { TaxInvoiceServiceEntity } from './tax-invoice-service.entity'

export class TaxInvoiceEntity {
    taxInvoiceId: string
    companyId: string
    personId: string
    invoiceId?: string
    services?: TaxInvoiceServiceEntity[]
    createdAt: Date
    updatedAt: Date
    lastSyncAt?: Date
    status: number
    statusCancellation: number

    requestAt?: Date
    requestLog?: any
    responseLog?: any
    responseMessage?: string
    responseCode?: string
    responseId?: string
    responseProtocol?: string

    resultAt?: Date
    resultLog?: any
    resultNFSeNumber?: string
    resultCityCode?: string

    cancelRequestAt?: Date
    cancelResponseId?: string
    cancelResponseMessage?: string

    cancelResultAt?: Date
    cancelResultCanceledAt?: Date
    cancelResultStatus?: string
    cancelResultMessage?: string

    // ISS retido (emissor nacional): 1 = não retido, 2 = retido pelo tomador. Só para tomador CNPJ.
    nfseISSRetido?: number

    person?: Person
}
